import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { useNavigate } from "react-router-dom";

import AssemblyDetailsEdit from "./AssemblyDetailsEdit";
import AssemblyDrawingsEdit from "./AssemblyDrawingsEdit";
import BOM from "./BOMEdit/BOM";
import AssemblyAssetsEdit from "./AssemblyAssetsEdit";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      width: "100%",
      background: "transparant",
    },
    button: {
      margin: theme.spacing(3),
      fontFamily: "Calibri",
      fontWeight: "bold",
      color: "White",
      fontSize: "15px",
      width: "95%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    text: {
      marginTop: theme.spacing(7),
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      fontSize: "30px",
      fontFamily: "Calibri",
      fontWeight: "bold",
      marginLeft: 35,
    },
    Line: {
      border: "1px solid #3F51B5",
      width: "15%",
      marginLeft: 35,
    },
  })
);

function getSteps() {
  return ["Assembly Details", "Drawings", "BOM", "Assets"];
}

export default function RegisterAssembly() {
  const Navigate = useNavigate();
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const steps = getSteps();

  const getStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <AssemblyDetailsEdit
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 1:
        return (
          <AssemblyDrawingsEdit
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 2:
        return (
          <BOM
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );
      case 3:
        return (
          <AssemblyAssetsEdit
            HandleNext={handleNext}
            HandleBack={handleBack}
            ActiveStep={activeStep}
          />
        );

      default:
        Navigate("/dashboard/management/items")
    }
  };

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  return (
    <>
      <div className="min-h-full flex items-center container my-5 ml-7">
        <div className=" w-full ">
          <div>
            <h2 className="text-left font-Montserrat text-xl font-bold text-black">
              Edit Assembly
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
          </div>
        </div>
      </div>

      <div className="max-w-full px-4 sm:px-6 lg:px-8">
        <div className={classes.root}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: { optional?: React.ReactNode } = {};
              if (isStepOptional(index)) {
                // labelProps.optional = (
                //   <Typography variant="caption">Optional</Typography>
                // );
              }
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <Typography className={classes.instructions}>
            {getStepContent(activeStep)}
          </Typography>
        </div>
      </div>
    </>
  );
}
